import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetWithdrawalsUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_WITHDRAWAL
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetWithdrawalsUserAction({
                    data: data.data,
                    count: data.count
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetWithdrawalsUser as SetGetWithdrawalsUser
}